import './styles/index.scss';

import * as React from 'react';

import * as Sentry from '@sentry/react';

import { getConfig } from './config';
import { App } from './containers/App/App';
import { checkLoginApp } from './helpers/Login';

Sentry.init({
  dsn: 'https://db4f5931d9ef4933b9adea48f43bdd0a@o173976.ingest.sentry.io/5723330',
  release: `g2r-activation-portal@${process.env.APP_VERSION}`,
  environment: getConfig().ENV,
});

checkLoginApp(<App />, window.location.origin);
